





























































import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import { getList } from '../api';
import moment from 'moment';
import { List } from 'vant';
Vue.use(List);
@Component({
  components: {
    SearchBar,
  },
})
export default class ListPage extends Vue {
  showList: boolean = false;
  placeholder: string = '请输入搜索关键词';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  key: string = '';
  show: boolean = true;
  userInputChange(data: string) {
    this.show = false;
    this.key = data;
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.list = [];
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
  onLoad() {
    this.showList = false;
    const data = {
      page: this.page,
      search: this.key,
    };
    getList(data).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.code === 200 && res.data && res.data.length) {
      res.data.map((item: any) => {
        item.create_date = moment(item.create_date * 1000).format('MM月DD日');
      });
      this.list = [...this.list, ...res.data];
    } else {
      this.list.length ? (this.showList = false) : (this.showList = true);
      this.finished = true;
    }
    this.loading = false;
  }
}
